import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FacetsPage } from '../../facets/facets-page/facets-page.component';
import { CardInfo } from './media-info-card.constant';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-media-info-card',
  templateUrl: './media-info-card.component.html',
  styleUrls: ['./media-info-card.component.scss'],
})
export class MediaInfoCardComponent extends FacetsPage {
  @Input() value: any;
  @Input() rowData: any;

  @Input() renderValue: CardInfo = {
    iconUrl: null,
    iconSize: 1.5,
    imgUrl: null,
    title: null,
    subHeading: null,
    subTitle: null,
    titleFontSize: 14,
    showTitle: false,
    truncateHeader: 100,
    truncateSubHeading: 100,
    toolTipText: null,
    url: null,
    iconPack: 'fci',
    isNbIcon: true,
    headerIcon: false,
    openNewTab: false,
    linkToolTip: null,
    headerSuffixComponent: null,
    textIcon: null,
    wideIconDimensions: false,
    textLink: false,
  };

  @Output() byLinkClick = new EventEmitter();

  constructor(
    activatedRoute: ActivatedRoute,
    private router: Router,
    private sanitizer: DomSanitizer,
  ) {
    super(activatedRoute);
  }

  hasIcon(): boolean {
    if (!this.renderValue.isNbIcon) return false;
    return (
      !!this.renderValue.iconUrl ||
      (!this.renderValue.headerIcon &&
        !!(this.renderValue.imgUrl || this.renderValue.textIcon))
    );
  }

  get sanitizedSubHeading(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.renderValue?.subHeading);
  }

  OnPageLoad(p: Params) {
    if (this.value) {
      try {
        const parsedValue = JSON.parse(this.value);
        this.renderValue = { ...this.renderValue, ...parsedValue };
      } catch (error) {
        this.renderValue = {};
      }
    }
  }

  get formattedTitle(): string {
    return this.renderValue?.title?.replace(/_/g, ' ') || '';
  }

  handleTitleClick(url) {
    // Emit event in all cases
    this.byLinkClick.emit({
      renderValue: this.renderValue,
      rowData: this.rowData,
    });

    // Navigate if URL is present
    if (url) {
      this.router.navigate([url]);
    }
  }
}
